/**
 * Created by rodrigo on 01/10/15.
 */

//Portuguese (BRAZIL) stopwords
// via https://sites.google.com/site/kevinbouge/stopwords-lists
module.exports = {
    stopwords: [
        "a",
        "à",
        "adeus",
        "agora",
        "aí",
        "ainda",
        "além",
        "algo",
        "algumas",
        "alguns",
        "ali",
        "ano",
        "anos",
        "antes",
        "ao",
        "aos",
        "apenas",
        "apoio",
        "após",
        "aquela",
        "aquelas",
        "aquele",
        "aqueles",
        "aqui",
        "aquilo",
        "área",
        "as",
        "às",
        "assim",
        "até",
        "atrás",
        "através",
        "baixo",
        "bastante",
        "bem",
        "boa",
        "boas",
        "bom",
        "bons",
        "breve",
        "cá",
        "cada",
        "catorze",
        "cedo",
        "cento",
        "certamente",
        "certeza",
        "cima",
        "cinco",
        "coisa",
        "com",
        "como",
        "conselho",
        "contra",
        "custa",
        "da",
        "dá",
        "dão",
        "daquela",
        "daquelas",
        "daquele",
        "daqueles",
        "dar",
        "das",
        "de",
        "debaixo",
        "demais",
        "dentro",
        "depois",
        "desde",
        "dessa",
        "dessas",
        "desse",
        "desses",
        "desta",
        "destas",
        "deste",
        "destes",
        "deve",
        "deverá",
        "dez",
        "dezanove",
        "dezasseis",
        "dezassete",
        "dezoito",
        "dia",
        "diante",
        "diz",
        "dizem",
        "dizer",
        "do",
        "dois",
        "dos",
        "doze",
        "duas",
        "dúvida",
        "e",
        "é",
        "ela",
        "elas",
        "ele",
        "eles",
        "em",
        "embora",
        "entre",
        "era",
        "és",
        "essa",
        "essas",
        "esse",
        "esses",
        "esta",
        "está",
        "estão",
        "estar",
        "estas",
        "estás",
        "estava",
        "este",
        "estes",
        "esteve",
        "estive",
        "estivemos",
        "estiveram",
        "estiveste",
        "estivestes",
        "estou",
        "eu",
        "exemplo",
        "faço",
        "falta",
        "favor",
        "faz",
        "fazeis",
        "fazem",
        "fazemos",
        "fazer",
        "fazes",
        "fez",
        "fim",
        "final",
        "foi",
        "fomos",
        "for",
        "foram",
        "forma",
        "foste",
        "fostes",
        "fui",
        "geral",
        "grande",
        "grandes",
        "grupo",
        "há",
        "hoje",
        "hora",
        "horas",
        "isso",
        "isto",
        "já",
        "lá",
        "lado",
        "local",
        "logo",
        "longe",
        "lugar",
        "maior",
        "maioria",
        "mais",
        "mal",
        "mas",
        "máximo",
        "me",
        "meio",
        "menor",
        "menos",
        "mês",
        "meses",
        "meu",
        "meus",
        "mil",
        "minha",
        "minhas",
        "momento",
        "muito",
        "muitos",
        "na",
        "nada",
        "não",
        "naquela",
        "naquelas",
        "naquele",
        "naqueles",
        "nas",
        "nem",
        "nenhuma",
        "nessa",
        "nessas",
        "nesse",
        "nesses",
        "nesta",
        "nestas",
        "neste",
        "nestes",
        "nível",
        "no",
        "noite",
        "nome",
        "nos",
        "nós",
        "nossa",
        "nossas",
        "nosso",
        "nossos",
        "nova",
        "novas",
        "nove",
        "novo",
        "novos",
        "num",
        "numa",
        "número",
        "nunca",
        "o",
        "obra",
        "obrigada",
        "obrigado",
        "oitava",
        "oitavo",
        "oito",
        "onde",
        "ontem",
        "onze",
        "os",
        "ou",
        "outra",
        "outras",
        "outro",
        "outros",
        "para",
        "parece",
        "parte",
        "partir",
        "paucas",
        "pela",
        "pelas",
        "pelo",
        "pelos",
        "perto",
        "pode",
        "pôde",
        "podem",
        "poder",
        "põe",
        "põem",
        "ponto",
        "pontos",
        "por",
        "porque",
        "porquê",
        "posição",
        "possível",
        "possivelmente",
        "posso",
        "pouca",
        "pouco",
        "poucos",
        "primeira",
        "primeiras",
        "primeiro",
        "primeiros",
        "própria",
        "próprias",
        "próprio",
        "próprios",
        "próxima",
        "próximas",
        "próximo",
        "próximos",
        "puderam",
        "quáis",
        "qual",
        "quando",
        "quanto",
        "quarta",
        "quarto",
        "quatro",
        "que",
        "quê",
        "quem",
        "quer",
        "quereis",
        "querem",
        "queremas",
        "queres",
        "quero",
        "questão",
        "quinta",
        "quinto",
        "quinze",
        "relação",
        "sabe",
        "sabem",
        "são",
        "se",
        "segunda",
        "segundo",
        "sei",
        "seis",
        "sem",
        "sempre",
        "ser",
        "seria",
        "sete",
        "sétima",
        "sétimo",
        "seu",
        "seus",
        "sexta",
        "sexto",
        "sim",
        "sistema",
        "sob",
        "sobre",
        "sois",
        "somos",
        "sou",
        "sua",
        "suas",
        "tal",
        "talvez",
        "também",
        "tanta",
        "tantas",
        "tanto",
        "tão",
        "tarde",
        "te",
        "tem",
        "têm",
        "temos",
        "tendes",
        "tenho",
        "tens",
        "ter",
        "terceira",
        "terceiro",
        "teu",
        "teus",
        "teve",
        "tive",
        "tivemos",
        "tiveram",
        "tiveste",
        "tivestes",
        "toda",
        "todas",
        "todo",
        "todos",
        "trabalho",
        "três",
        "treze",
        "tu",
        "tua",
        "tuas",
        "tudo",
        "um",
        "uma",
        "umas",
        "uns",
        "vai",
        "vais",
        "vão",
        "vários",
        "vem",
        "vêm",
        "vens",
        "ver",
        "vez",
        "vezes",
        "viagem",
        "vindo",
        "vinte",
        "você",
        "vocês",
        "vos",
        "vós",
        "vossa",
        "vossas",
        "vosso",
        "vossos",
        "zero"
    ]
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/pt.js
 ** module id = 2970
 ** module chunks = 0
 **/